export enum PageBuilderApiActionType {
    WIDGET_PROPS_UPDATED = 'widget-props-updated',
    TOGGLE_EDIT_MODE = 'toggle-edit-mode',
    HIGHLIGHT_CHILD_ELEMENT = 'highlight-child-element',
    WIDGET_RESIZED = 'widget-resized',
}
